import axios from "axios";

export function compareDates(date1: Date, date2: Date): boolean {
    return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
}

export function offsetDate(date: Date) {
    return new Date(date.getTime() + Math.abs(date.getTimezoneOffset()*60000));
}

export function offsetDatetime(date: Date) {
    return new Date(date.getTime() - Math.abs(date.getTimezoneOffset()*60000));
}

export const BACKEND_URL = 'http://lincelegal.net/';

export function get({ url, token }: {url: string, token?: string}) {
    const headers: any = {
        'Content-Type': 'application/json',
    };
    if(token) {
        headers['Authorization'] = 'Bearer ' + token;
    }
    return axios({
        method: 'get',
        url: BACKEND_URL + url,
        headers: headers,
        withCredentials: true,
      });
}

export function post({ url, data, token }: {url: string, data: FormData, token?: string}) {
    const headers: any = {
        'Content-Type': 'multipart/form-data'
    };
    if(token) {
        headers['Authorization'] = 'Bearer ' + token;
    }
    return axios({
        method: 'post',
        url: BACKEND_URL + url,
        data: data,
        headers: headers,
        withCredentials: true,
      });
}

export enum FormatType {
    CHART,
    DOCUMENT
}

export function formatDate(date: Date, type: FormatType = FormatType.CHART ) {
    const day = date.getDate(); // Gets the day of the month (1-31)
    const month = date.toLocaleString('es-ES', { month: 'long' }); // Gets the month name in Spanish (e.g., 'febrero')
    const year = date.getFullYear(); // Gets the full year (e.g., 2025)

    if(type === FormatType.CHART) return `${day} / ${month} / ${year}`;
    if(type === FormatType.DOCUMENT) return `${day}-${month}-${year}`;
}

export function formatDateToLocale(date: Date) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
}